/* OTM — recipe quick-add.
   Adds the recipe's OTM bottle as a ONE-TIME purchase and opens the cart.
   Any selling_plan a subscription app may have injected is stripped before the
   request, so a recipe page can never start a subscription by accident.
   Guarded so duplicate script tags cannot double-bind the listener. */
(function () {
  if (window.__otmRecipeQuickAdd) return;
  window.__otmRecipeQuickAdd = true;

  function addUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart/add.js';
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('form[data-otm-quickadd]');
    if (!form) return;
    ev.preventDefault();

    var sp = form.querySelector('[name="selling_plan"]');
    if (sp) sp.parentNode.removeChild(sp);

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) { form.removeAttribute('data-otm-quickadd'); form.submit(); return; }

    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        form.removeAttribute('data-otm-quickadd');
        form.submit();
      });
  });
})();
